export default "__VITE_ASSET__BmoS106D__"